import { Typography } from '@mui/material'
import React from 'react'
// ✅ Right
// ✅ Alternate correct path
// import { MWLImagePopupViewer } from 'react-web-white-label'
// import 'react-image-gallery/styles/css/image-gallery.css'
// import './DpsImagePopup.css'

const DpsImagePopup = ({
  downloadAction = () => {},
  popupImage,
  footerContent,
  handleDeleteItem = () => {},
  headerContent,
  onClose = () => {},
  open = false,
  showCheckbox = false,
  showThumbnails,
  buttonConfig,
  thumbnailDownloadPosition = 'bottom-right',
  thumbnailPosition = 'right',
}) => {
  // Wrap single object in an array, or use empty array if undefined
  const mappedImages = Array.isArray(popupImage)
    ? popupImage.map((image) => ({
        downloadUrl: image.attachmentURL || image.fullURL,
        fileName: image.fileName || image.title,
        original: image.attachmentURL || image.fullURL,
        thumbnail: image.attachmentURL || image.fullURL,
      }))
    : popupImage
    ? [
        {
          downloadUrl: popupImage.attachmentURL || popupImage.fullURL,
          fileName: popupImage.fileName || popupImage.title,
          original: popupImage.attachmentURL || popupImage.fullURL,
          thumbnail: popupImage.attachmentURL || popupImage.fullURL,
        },
      ]
    : []

  const testImages = [
    {
      downloadUrl:
        'https://strtestdefault.blob.core.windows.net/caseattachments/4/case/qa00378345/VDAPFIStatement_794ad785-a921-4a72-9f45-f45aaea24de2.pdf?sv=2021-10-04&st=2025-11-03T10%3A35%3A03Z&se=2025-11-03T11%3A35%3A03Z&sr=b&sp=r&sig=sFKEAP1GU52Qsi7q8nMYz7Rw%2FiVsosf20wWtt1GxsrA%3D',
      fileName: 'testPdf.pdf',
      original:
        'https://strtestdefault.blob.core.windows.net/caseattachments/4/case/qa00378345/VDAPFIStatement_794ad785-a921-4a72-9f45-f45aaea24de2.pdf?sv=2021-10-04&st=2025-11-03T10%3A35%3A03Z&se=2025-11-03T11%3A35%3A03Z&sr=b&sp=r&sig=sFKEAP1GU52Qsi7q8nMYz7Rw%2FiVsosf20wWtt1GxsrA%3D',
      thumbnail:
        'https://strtestdefault.blob.core.windows.net/caseattachments/4/case/qa00378345/VDAPFIStatement_794ad785-a921-4a72-9f45-f45aaea24de2.pdf?sv=2021-10-04&st=2025-11-03T10%3A35%3A03Z&se=2025-11-03T11%3A35%3A03Z&sr=b&sp=r&sig=sFKEAP1GU52Qsi7q8nMYz7Rw%2FiVsosf20wWtt1GxsrA%3D',
    },
    {
      downloadUrl:
        'https://strtestdefault.blob.core.windows.net/caseattachments/4/case/qa00378345/red_527892db-e077-4681-9e1e-9a83716da221.jpg?sv=2021-10-04&st=2025-11-03T10%3A24%3A46Z&se=2025-11-03T11%3A24%3A46Z&sr=b&sp=r&sig=bSHN2H6fBp6%2BR3f%2Bux094Mig%2BBjf4NlwTwlZWLPBx2w%3D',
      fileName: 'red.jpg',
      original:
        'https://strtestdefault.blob.core.windows.net/caseattachments/4/case/qa00378345/red_527892db-e077-4681-9e1e-9a83716da221.jpg?sv=2021-10-04&st=2025-11-03T10%3A24%3A46Z&se=2025-11-03T11%3A24%3A46Z&sr=b&sp=r&sig=bSHN2H6fBp6%2BR3f%2Bux094Mig%2BBjf4NlwTwlZWLPBx2w%3D',
      thumbnail:
        'https://strtestdefault.blob.core.windows.net/caseattachments/4/case/qa00378345/red_527892db-e077-4681-9e1e-9a83716da221.jpg?sv=2021-10-04&st=2025-11-03T10%3A24%3A46Z&se=2025-11-03T11%3A24%3A46Z&sr=b&sp=r&sig=bSHN2H6fBp6%2BR3f%2Bux094Mig%2BBjf4NlwTwlZWLPBx2w%3D',
    },
  ]
  return (
    <div>
      {/* <MWLImagePopupViewer
        downloadAction={downloadAction}
        footerContent={footerContent}
        handleDeleteItem={handleDeleteItem}
        headerContent={headerContent}
        images={mappedImages}
        onClose={onClose}
        showCheckbox={showCheckbox}
        showThumbnails={true}
        thumbnailDownloadPosition={thumbnailDownloadPosition}
        thumbnailPosition={thumbnailPosition}
        open={open}
        buttonConfig={buttonConfig}
      /> */}
    </div>
  )
}

export default DpsImagePopup
